type QuantityItem = {
  quantity?: number | null;
};

export const getCartTotalQuantity = (items?: QuantityItem[] | null) => {
  return items?.reduce((total, item) => total + (Number(item.quantity) || 0), 0) ?? 0;
};
